import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dimmer, Header, Icon, Segment } from 'semantic-ui-react';
import { ChatComponent } from './components';

import { Actions } from '../../ducks/chat';
const { ActionsChannels, ActionsMessages } = Actions;

const { subscribe, unsubscribeFromAll } = ActionsChannels.thunks;
const {
  historyForChannel,
  listen,
  sendMessageToChannel,
} = ActionsMessages.thunks;

class Chat extends React.Component {
  defaultChannel = 'flynn';

  constructor(props) {
    super(props);
    this.state = {
      selectedChannel: this.defaultChannel,
    };
    this._handleSendMessage = this._handleSendMessage.bind(this);
  }
  _handleSendMessage(message) {
    const { currentUser } = this.props;
    const active = currentUser && currentUser.active;
    if (!active) {
      return;
    }
    this.props.sendMessageToChannel(message, this.defaultChannel);
  }

  componentDidMount() {
    this.props.listen();
    this.props.subscribe([this.defaultChannel]);
    // This should prob change to new channel
    this.props.historyForChannel(this.defaultChannel);
  }

  componentWillUnmount() {
    this.props.unsubscribeFromAll();
  }

  render() {
    const { currentUser, chat } = this.props;
    const { channels, messages } = chat;
    if (!currentUser) {
      return <span />;
    }
    let data = [];
    let occupancy = 0;
    if (channels[this.defaultChannel]) {
      data = channels[this.defaultChannel].messages.map(
        messageId => messages[messageId],
      );
      if (channels[this.defaultChannel].presence) {
        occupancy = channels[this.defaultChannel].presence.occupancy;
      }
    }
    const active = !currentUser || !currentUser.active;
    return (
      <Dimmer.Dimmable
        as={Segment}
        style={{ padding: 0, maring: 0 }}
        blurring
        dimmed={active}
        basic
      >
        <Dimmer inverted active={active}>
          <Header size="small" icon>
            <Icon name="lock" />Private Beta
          </Header>
        </Dimmer>
        <ChatComponent
          onSendMessage={this._handleSendMessage}
          currentUser={currentUser}
          messages={data}
          occupancy={occupancy}
        />
      </Dimmer.Dimmable>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
    chat: state.chat,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      historyForChannel,
      listen,
      sendMessageToChannel,
      subscribe,
      unsubscribeFromAll,
    },
    dispatch,
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(Chat);



// WEBPACK FOOTER //
// ./src/containers/Chat/index.jsx